import React from "react";
import { Table, Modal, Button } from "antd";
import moment from "moment-timezone";
import "./DeckTable.css";
const { Column } = Table;

const DeckTable = ({ decks, onEditClick, showComments, featuredId }) => {
  console.log("print dack", featuredId, decks);
  return (
    <div>
      <h1 style={{ textIndent: 50 }}>Edit Article</h1>
      <Table
        dataSource={decks}
        rowClassName={(record, index) =>
          record.id == featuredId ? "table-row-light" : "table-row-dark"
        }
      >
        <Column title="Title" dataIndex="title" key="title" />
        <Column
          title="Image"
          key="imageUrl"
          render={(text, record) => (
            <img
              alt="card"
              className="thumbnail"
              src={
                record.imageUrl
                  ? record.imageUrl
                  : "https://pngimage.net/wp-content/uploads/2018/06/placeholder-png-4.png"
              }
            />
          )}
        />
        <Column
          title="Date"
          key="date"
          render={(text, record) => (
            <p>{new Date(record.date).toLocaleDateString()}</p>
          )}
        />
        <Column
          title="Timer"
          key="timer"
          render={(text, record) => (
            <p>
              {record.timer
                ? moment(record.timer).format("YYYY-MM-DD HH:mm:ss")
                : "null"}
            </p>
          )}
        />
        <Column
          title="Tags"
          key="tags"
          render={(text, record) =>
            record.tags &&
            record.tags.map((item, index) => <p key={index}>{item}</p>)
          }
        />
        <Column
          title="Action"
          key="name"
          render={(text, record) => (
            <span>
              <a
                onClick={() => onEditClick(record)}
                style={{ marginRight: 16 }}
              >
                Edit {record.name}
              </a>
            </span>
          )}
        />
        <Column
          title="Comments"
          key="comment"
          render={(text, record) => (
            <span>
              {!record.timer ? (
                <a onClick={() => showComments(record)}>Comments</a>
              ) : null}
            </span>
          )}
        />
        <Column
          title="Author"
          render={(text, record) => (
            <p>{record.authorIs ? record.authorIs : ""}</p>
          )}
        />
      </Table>
    </div>
  );
};

export default DeckTable;
